module.exports = __webpack_public_path__ + "static/workshop-resources@2x-d1ced04e2e49842f57d78143c52fa23b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/workshop-resources@2x.jpg
// module id = 2706
// module chunks = 157636680307020